import { memo, useCallback, useEffect, useMemo, useState } from "react";
import Parallax from "parallax-js";
import ParticlesBackground from "../ParticlesBackground";
import CV from "../CV";
import styles from "./App.module.scss";
import Player from "../Player";
import Cursor, { CURSOR_ENUM } from "../Cursor";
import Favicon from "../Favicon";
import CursorContext from "../../contexts/cursor.context";
import FaviconContext from "../../contexts/favicon.context";
import { FAVICON_ENUM } from "../Favicon/Favicon";

function App() {
  const [cur, setCur] = useState(CURSOR_ENUM.DEFAULT);
  const [fav, setFav] = useState(FAVICON_ENUM.DEFAULT);

  const setCursor = useCallback((cursor: CURSOR_ENUM) => {
    setCur(cursor);
  }, []);

  const cursorContext = useMemo(
    () => ({ cursor: cur, setCursor }),
    [cur, setCursor]
  );

  const setFavicon = useCallback((favicon: FAVICON_ENUM) => {
    setFav(favicon);
  }, []);

  const faviconContext = useMemo(
    () => ({ favicon: fav, setFavicon }),
    [fav, setFavicon]
  );

  useEffect(() => {
    const scene = document.getElementById("parallax-scene");
    if (scene) {
      const parallaxInstance = new Parallax(scene);
    }
  }, []);

  return (
    <div className={styles.app}>
      <ParticlesBackground />
      <CursorContext.Provider value={cursorContext}>
        <div id="parallax-scene">
          <CV />
        </div>
        <CursorContext.Consumer>
          {({ cursor }) => <Cursor cursor={cursor} />}
        </CursorContext.Consumer>
        <FaviconContext.Provider value={faviconContext}>
          <Player setFavicon={setFavicon} setCursor={setCursor} />
          <FaviconContext.Consumer>
            {({ favicon }) => <Favicon icon={favicon} />}
          </FaviconContext.Consumer>
        </FaviconContext.Provider>
      </CursorContext.Provider>
    </div>
  );
}

export default memo(App);
